<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="合同基本信息" name="base">
        <base-edit-form
          ref="baseEditForm"
          :disabled="isDisableEdit"
          :isEditStatus="isEditStatus"
          :code="params.contractCode"
          @chargeUnitChange="(val) => (chargeUnit = val)"
        />

        <div class="d-flex justify-content-end mt-2 mb-2" v-if="!isDisableEdit">
          <el-button type="primary" size="small" @click="save()"
            >保存</el-button
          >
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="线路信息"
        name="line"
        :disabled="!params.contractCode"
      >
        <line-edit-form
          ref="lineEditForm"
          :disabled="isDisableEdit"
          :contractCode="params.contractCode"
        />
      </el-tab-pane>
      <el-tab-pane label="附加费用" name="fee" :disabled="!params.contractCode">
        <fee-edit-form
          ref="feeEditForm"
          :disabled="isDisableEdit"
          :contractCode="params.contractCode"
        />
      </el-tab-pane>
      <el-tab-pane
        label="包车费用"
        name="chartersfee"
        :disabled="!params.contractCode"
      >
        <ChartersFeeEditForm
          ref="chartersfeeEditForm"
          :disabled="isDisableEdit"
          :contractCode="params.contractCode"
        />
      </el-tab-pane>
      <el-tab-pane
        label="拼点费用"
        name="spellfee"
        :disabled="!params.contractCode"
      >
        <SpellFeeEditForm
          ref="spellfeeEditForm"
          :disabled="isDisableEdit"
          :contractCode="params.contractCode"
        />
      </el-tab-pane>
      <!-- <el-tab-pane label="扩展字段" name="extend">
        <extend-edit-form ref="extendEditForm" :disabled="isDisableEdit" />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import BaseEditForm from '../components/base-edit-form'
import FeeEditForm from '../components/fee-edit-form'
import LineEditForm from '../components/line-edit-form'
import SpellFeeEditForm from '../components/spellfee-edit-form'
import ChartersFeeEditForm from '../components/charters'
// import ExtendEditForm from '../components/extend-edit-form'
export default {
  name: 'contract-customerContract-detail',
  components: {
    BaseEditForm,
    FeeEditForm,
    LineEditForm,
    SpellFeeEditForm,
    ChartersFeeEditForm,
  },
  provide() {
    return {
      detailPage: this,
    }
  },
  data() {
    return {
      activeName: 'base',
      chargeUnit: '',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEdit() {
      return this.pageType === 'detail'
    },
    // 是否是编辑状态
    isEditStatus() {
      return this.pageType === 'edit'
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    save() {
      this.$refs[`${this.activeName}EditForm`]
        .save()
        .then(async (res) => {
          if (this.activeName === 'base' && this.pageType === 'add') {
            await this.close({
              tagName: this.$route.fullPath,
              showConfirm: false,
            })
            this.$router.push({
              name: 'contract-customerContract-detail',
              params: {
                pageType: 'edit',
                contractCode: res,
              },
            })
          }
        })
        .catch(() => {})
    },
  },
}
</script>
